import { Field, Input, InputProps, Text } from "@fluentui/react-components";
import BodyPresenceMotion from "./BodyPresenceMotion";
import { useDeviceDrawerStore } from "../../store/DeviceDrawerStore";
import { InputStateProps } from "../../hooks/useDeviceFormHook";

type DeviceStatsInfoProps = {
    styles: string;
    cpuState: InputStateProps<string>;
    memoryState: InputStateProps<string>;
    diskState: InputStateProps<string>;
    priceState: InputStateProps<number>;
};

export default function DeviceStatsInfo({ styles, cpuState, memoryState, diskState, priceState }: DeviceStatsInfoProps) {
    const { isForward, level } = useDeviceDrawerStore();

    const handleInputChange = (state: InputStateProps<number>, max: number): InputProps["onChange"] => {
        return (_, data) => {
            const value = parseInt(data.value, 10);
            if (value < 0) {
                // state.setValue(0);
                return;
            }
            if (value > max) {
                // state.setValue(max);
                return;
            }
            state.setValue(value);
        };
    };

    return (
        <BodyPresenceMotion isForward={isForward} visible={level === 5} unmountOnExit={true}>
            <div className={styles}>
                <Field label="CPU">
                    <Input
                        id={cpuState.id}
                        type="text"
                        max={999}
                        min={0}
                        value={cpuState.value ?? ""}
                        onChange={(_, data) => cpuState.setValue(data.value)}
                    />
                </Field>

                <Field label="Memory">
                    <Input
                        id={memoryState.id}
                        type="number"
                        max={999}
                        min={0}
                        value={memoryState.value ?? ""}
                        onChange={(_, data) => memoryState.setValue(data.value)}
                    />
                </Field>

                <Field label="Disk">
                    <Input
                        id={diskState.id}
                        type="number"
                        max={9999}
                        min={0}
                        value={diskState.value ?? ""}
                        onChange={(_, data) => diskState.setValue(data.value)}
                    />
                </Field>

                <Field label="Price">
                    <Input
                        contentBefore={<Text size={400} id="beforeLabelId">$</Text>}
                        id={priceState.id}
                        type="number"
                        max={999999999}
                        min={0}
                        value={priceState.value?.toString()}
                        onChange={handleInputChange(priceState, 999999999)}
                    />
                </Field>
            </div>
        </BodyPresenceMotion>
    );
}
